import React from 'react';
import { ListItemWithText } from '@ihsm/ui-shared/lib/typings/shared/components/ListWithRowDrag/types';
import './MetricParameterDraggableItem.scss';

export interface MetricParameterDraggableItemProps extends ListItemWithText {
  text: string;
  type?: string;
  selectedOption?: string;
  options?: string[];
  onRemove: () => void;
  onChangeOption: (value: string) => void;
  disabled?: boolean;
}

export const MetricParameterDraggableItem: React.FC<
  MetricParameterDraggableItemProps
> = ({
  text = 'Empty Text',
  type,
  options,
  onRemove = () => {},
  onChangeOption = () => {},
  disabled = false,
}): JSX.Element => (
  <div className="metrics-parameters-draggable">
    <div className="metrics-parameters-draggable__text">{text}</div>

    {options && options.length > 0 ? (
      <select
        onChange={(e) => onChangeOption(e.target.value)}
        className="metrics-parameters-draggable__badge"
        value={type}
      >
        {options.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </select>
    ) : null}

    {!disabled ? (
      <button
        onClick={onRemove}
        type="button"
        className="metrics-parameters-draggable__remove"
      >
        &times;
      </button>
    ) : null}
  </div>
);
